export class ClientSearchDataModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class ClientSearchData extends ClientSearchDataModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
